import {
  BOTTOM_PADDING_CONTAINER,
  BUTTON_HEIGHT,
  FORM_ELEMENT_TYPE,
  FORM_FIELD_LABEL_POSITION,
  LINE_GAP,
  MIN_COLLAPSED_LC_HEIGHT,
  MIN_HEIGHT_FIELD,
  MIN_HEIGHT_FIELD_DIALOG,
  MIN_HEIGHT_FIELD_DIALOG_WITH_LABEL,
  MIN_HEIGHT_FIELD_WITH_LABEL,
  MIN_HEIGHT_MULTILINE_FIELD,
} from '@constants'
import { FormDataEnriched, FormTab } from '@types'

export const getTabHeight = (
  tab: FormTab<FormDataEnriched>,
  isDialogWindow: boolean,
  listControlStates?: Record<number, { expanded: boolean; height: number }>
): number => {
  let sum = 0
  tab.lines.forEach((line, index) => {
    if (index === tab.lines.length - 1) return
    if (index !== 0) sum += LINE_GAP

    const hasMultilineField = line.elements.some(({ data }) => data?.isMultiline)
    const hasField = line.elements.some(
      ({ type, titleHidden, labelPosition }) =>
        type === FORM_ELEMENT_TYPE.FIELD &&
        !titleHidden &&
        labelPosition === FORM_FIELD_LABEL_POSITION.TOP
    )
    const hasButton = line.elements.some(({ type }) => type === FORM_ELEMENT_TYPE.ACTION_BUTTON)
    const isView = line.elements.length && line.elements[0].type === FORM_ELEMENT_TYPE.VIEW

    if (isView) {
      const listControlId = line.elements?.[0]?.id
      const state = listControlStates?.[listControlId]

      sum += state?.expanded ? state.height : MIN_COLLAPSED_LC_HEIGHT
    }

    if (hasMultilineField) {
      sum += MIN_HEIGHT_MULTILINE_FIELD
    } else if (hasField) {
      sum += isDialogWindow ? MIN_HEIGHT_FIELD_DIALOG_WITH_LABEL : MIN_HEIGHT_FIELD_WITH_LABEL
    } else if (hasButton) {
      sum += BUTTON_HEIGHT
    } else {
      sum += isDialogWindow ? MIN_HEIGHT_FIELD_DIALOG : MIN_HEIGHT_FIELD
    }
  })

  if (sum === 0) {
    const minHeightField = isDialogWindow
      ? MIN_HEIGHT_FIELD_DIALOG_WITH_LABEL
      : MIN_HEIGHT_FIELD_WITH_LABEL

    return minHeightField + BOTTOM_PADDING_CONTAINER
  }

  return sum + BOTTOM_PADDING_CONTAINER
}
